import { FormControl, FormLabel, Input, Switch } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";

import CustomRadioGroup from "components/ui/CustomRadioGroup";
import FixedBar from "components/ui/FixedBar";
import SubmitButton from "components/ui/SubmitButton";
import { useSuccessDialogContext } from "components/ui/SuccessDialog/SuccessDialogContext";
import { useMessages } from "hooks/useMessages";
import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { ThemeInputs, useSaveTheme } from "../hooks/useSaveTheme";

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  language: Yup.string().required(),
});

type UserFormProps = {
  theme?: any;
};

export default function ThemeForm({ theme }: UserFormProps) {
  const defaultValues: ThemeInputs = {
    name: theme?.name,
    language: theme?.language || "PT_BR",
    active: theme?.active,
  };

  const navigate = useNavigate();
  const { openSuccessDialog } = useSuccessDialogContext();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors, isValid },
  } = useForm<ThemeInputs>({
    mode: "all",
    resolver: yupResolver(validationSchema) as Resolver<ThemeInputs>,
    defaultValues,
  });

  const { onError } = useMessages();

  const isActive = watch("active");

  const { onSaveTheme, isPending } = useSaveTheme({
    themeId: theme?.id,
    onSuccess: () => {
      reset();
      navigate("/temas");
      if (!theme?.id) {
        openSuccessDialog({
          title: "Novo tema cadastrado!",
          description: "",
          actionButtonText: "Criar mais um tema",
          actionButton: "/temas/novo",
          closeButtonText: "Tudo certo",
        });
      }
    },
    onError: (error) => onError(error?.response?.data?.message),
  });

  const onSubmit: SubmitHandler<ThemeInputs> = (data) => onSaveTheme(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={!!errors.name} isRequired>
        <FormLabel>Nome</FormLabel>
        <Input {...register("name")} autoFocus />
      </FormControl>

      <FormControl
        isInvalid={!!errors.language}
        isRequired
        maxW={{ lg: "250px" }}
      >
        <FormLabel>Idioma</FormLabel>
        <CustomRadioGroup
          name="language"
          defaultValue={defaultValues.language}
          onChange={(value) =>
            setValue("language", value, { shouldValidate: true })
          }
          options={[
            {
              label: "Português",
              value: "PT_BR",
            },
            {
              label: "Inglês",
              value: "EN",
            },
          ]}
        />
      </FormControl>

      {theme && (
        <FormControl isInvalid={!!errors.active}>
          <FormLabel>Status</FormLabel>
          <Switch {...register("active")}>
            {isActive ? "Ativo" : "Inativo"}
          </Switch>
        </FormControl>
      )}

      <FixedBar>
        <SubmitButton isDisabled={isPending || !isValid} isLoading={isPending}>
          {!theme ? "Cadastrar" : "Atualizar"}
        </SubmitButton>
      </FixedBar>
    </form>
  );
}
